<template>
  <div>
    <SignaturePad
      :showSignaturePad="showSignaturePad"
      @close="showSignaturePad = false"
      @signatureData="signatureData"
    />
    <v-card min-height="40vh">
      <v-col
        cols="12"
        class="white--text text-uppercase text-center text-caption"
        style="background-color: #2b3990; "
        >{{ title }}
      </v-col>
      <v-col cols="12" md="12">
        <p class="text-caption">
         {{ userCompany }} has established and, when appropriate, will modify or change certain rules and regulations regarding
         the conduct of employees and the appropriate discipline for any violation. Rules of conduct for employees are intended
         to promote the orderly and efficient operation of {{ userCompany }}. Violations, therefore, shall be regarded as cause for
         disciplinary action.
        </p>
        <p class="text-caption">
        As stated in your job description, staff must ensure all client and program paperwork you are responsible for is continuosly
        organized, up-to-date, accurate, and prepared for month-end submission. All reports (ADL's, time sheets, MAR's and behavior reports)
        must be completed by the end of each and every shift. Failure to have all reports (ADL's time sheets, MAR's and behavior reports)
        completed by the end of each and every shift will result in your paycheck being held until all reports are up-to-date.</p>

        <p class="text-caption">
        We require reports to be completed daily because it is a state requirements and without them, we are n jeopardy of being out of compliance.
        It is considered Medicaid Fraud when we are not able to provide proof for the hours spent caring for our clients.
        </p>

        <p class="text-caption">
        It is {{ userCompany }} desire to continue to serve our community and our clients the best way we can.
        </p>

        <p class="text-caption">
        I acknowledgement of receipt of this policy:
        </p>

      </v-col>
      <v-col cols="12" md="12">
        <v-row>
          <v-col cols="12" md="4">
            <div style="position: relative">
              <v-text-field
                label="Employee's Signature"
                @click.stop="showSignaturePad = true"
              ></v-text-field>
              <v-img
                width="150"
                height="50"
                :src="employeeSignatureInReporting"
                style="position:absolute;top:10px;right:150px;"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" md="3">
            <v-menu
              ref="menu"
              v-model="dateMenu"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="item.dateSignedInReporting"
                  label="Date"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                no-title
                v-model="item.dateSignedInReporting"
                @input="dateMenu = false"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-row>
         <v-col>
            <v-row align="center" justify="start">
              <v-card-actions>
                <v-btn @click="prev">Prev</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
          <v-col>
            <v-row align="center" justify="end">
              <v-card-actions>
                <v-btn @click="next">Next</v-btn>
              </v-card-actions>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-card>
  </div>
</template>
<script>
/* eslint-disable */
import SignaturePad from "@/components/SignaturePad";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import download from "downloadjs";

export default {
  components: { SignaturePad },
  props: {
    title: {
      type: String,
      default: "",
    },
    user: {
      type: Object,
    },
    currentStep: {
      type: Number,
    },
  },
  data: function() {
    return {
      dateMenu: false,
      employeeSignature: "",
      showSignaturePad: false,
      item: {},
      step: this.currentStep,
    };
  },

  created() {
    this.populateUserInfo();
    const savedSignature = localStorage.getItem("employeeSignatureInReporting");
    if (savedSignature) {
      this.signatureData(savedSignature);
    }
  },

  computed: {
    ...mapGetters("userDocuments", ["getUserDocuments"]),
    ...mapGetters("users", {
      user: "user",
      userCompany: "userCompany",
    }),
  },

  methods: {
    ...mapActions({
      getDocuments: "userDocuments/getDocuments",
      addTransportationDoc: "userDocuments/saveTransportationDocument",
      addDocument: "userDocuments/updateDocument",
      downloadDocuments: "userDocuments/downloadDocuments",
    }),
    signatureData(data) {
      this.employeeSignatureInReporting = data;
      localStorage.setItem("employeeSignatureInReporting", data);
    },

    next() {
      this.addItem();
      // this.generatePDF();
      this.$emit("clicked", this.step + 1);
    },
    prev() {
      this.$emit("clicked", this.step - 1);
    },
    async addItem() {
      try {
        const response = await this.addDocument({
          data: { ...this.item, Employee: this.user._id },
          pdfDocument: "client-transportation-agreement",
        });
        console.log(response);
         localStorage.setItem('dateSignedInReporting', this.item.dateSignedInReporting);
      } catch (error) {
        console.log(error);
      }
    },

    async populateUserInfo() {

       if (localStorage.getItem('dateSignedInReporting')) {
        this.item.dateSignedInReporting = localStorage.getItem('dateSignedInReporting');
      }

      this.item.employeeName = this.user.Name;

      const response = await this.getDocuments(this.user._id);

      let documents = this.updateCase(
        response.data.document.Documents.ClientTransportationAgreement
      );

      this.item = Object.assign(
        {},
        {
          ...documents,
          employeeName: response.data.document.Employee.Name,
          dateSignedInReporting: this.item.dateSignedInReporting,
        }
      );
    },

    async generatePDF() {
      const response = await this.downloadDocuments({
        id: this.user._id,
        pdfDocument: "client-transportation-agreement",
      });
      let pdfFile =
        "data:application/octet-stream;base64," + response.data.data;
      download(
        pdfFile,
        "client-transportation-agreement.pdf",
        "application/pdf"
      );
    },

    updateCase(obj) {
      let output = Object.entries(obj).map(([key, value]) => [
        key[0].toLowerCase() + key.slice(1),
        value,
      ]);
      return Object.fromEntries(output);
    },
  },
};
</script>
<style scoped>
.theme--light.v-btn.v-btn--has-bg {
  background-color: #2b3990;
  color: #fff;
  border-radius: 1.25rem;
}
</style>
